import { getTextColor } from "utils/functions/getColor.js";
import { useTheme } from "context/theme-context";
export const BookmarkIcon = () => {
    const { theme } = useTheme();
  return (
    <svg width="1.5em" style={{color: getTextColor(theme) }} height="1.5em" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22V4c0-1.103-.897-2-2-2zm0 16.553l-6-3.428l-6 3.428V4h12v14.553z"
      ></path>
    </svg>
  );
};
export const BookmarkedIcon = () => {
    const { theme } = useTheme();
  return (
    <svg width="1.5em" style={{color: getTextColor(theme) }} height="1.5em" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 21V5q0-.825.588-1.413Q6.175 3 7 3h10q.825 0 1.413.587Q19 4.175 19 5v16l-7-3Z"
      ></path>
    </svg>
  );
};
